let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k422C")).then(() => parcelRequire('Y851Q'));